import React from "react";

const FieldError = ({ children }) => children
  ? <span className="ql-exam-field-error">{children}</span>
  : null;

const Cell = ({ children, className = "" }) => <span className={`hm-cell ${className}`}>{children}</span>;

function HeaderMock({ code }) {
  const logo = <span className="hm-logo" aria-hidden="true">🏫</span>;
  const bilingual = <><Cell>RÉPUBLIQUE DU<br />CAMEROUN<br />★★★<br />MINESEC<br />★★★</Cell>{logo}<Cell className="right">REPUBLIC OF<br />CAMEROON<br />★★★<br />MoSE<br />★★★</Cell></>;
  const details = <span className="hm-details">Examen&nbsp; | &nbsp;Niveau&nbsp; | &nbsp;Classe&nbsp; | &nbsp;Séance&nbsp; | &nbsp;Date<br />Épreuve&nbsp; | &nbsp;Matière&nbsp; | &nbsp;Coef&nbsp; | &nbsp;Durée</span>;
  const variants = {
    0: <>{bilingual}<span className="hm-meta">Matière&nbsp; | &nbsp;Classe&nbsp; | &nbsp;Durée&nbsp; | &nbsp;Coeff&nbsp; | &nbsp;Note</span><b className="hm-title">TITRE DE L’ÉPREUVE</b></>,
    1: <><Cell>NOM ÉCOLE<br />DÉPARTEMENT<br />Adresse / Tél.</Cell>{logo}<Cell className="right">ANNÉE SCOLAIRE<br />PÉRIODE<br />CLASSE<br />DURÉE<br />COEFF</Cell><b className="hm-title">TITRE SOULIGNÉ</b></>,
    2: <><Cell>NOM ÉCOLE<br />Adresse<br />Département</Cell>{logo}<Cell className="right">DIOCÈSE / TUTELLE<br />CLASSE<br />Durée / Coef</Cell><b className="hm-title">TITRE CENTRÉ</b></>,
    3: <><span className="hm-table hm-table-three"><i>École<br />Adresse<br />Département</i><i>{logo}</i><i>Année<br />Session<br />Mois</i><strong>ÉPREUVE DE MATIÈRE</strong><small>Niveau</small><small>Durée</small><small>Coeff</small></span></>,
    4: <><Cell>NOM ÉCOLE<br />DÉPARTEMENT</Cell><Cell className="right wide-right">ANNÉE SCOLAIRE<br />SESSION / TYPE<br />SÉRIE : DURÉE<br />COEFF<br />ÉPREUVE : MATH</Cell><b className="hm-title">TITRE</b></>,
    5: <><Cell>MINESEC<br />OFFICE DU<br />BACC<br />Nom École</Cell>{logo}<Cell className="right">Examen<br />Session<br />Série<br />Durée / Coef<br />Examinateur</Cell><b className="hm-title">TITRE</b></>,
    6: <><Cell className="center">Ministère<br /><b>NOM ÉCOLE</b><br />Département</Cell>{logo}<Cell className="center">Année<br />Période n°<br />Classe<br />Durée ; Coeff<br />Examinateur</Cell><b className="hm-title">TITRE</b></>,
    7: <><b className="hm-school">NOM DE L’ÉCOLE</b>{logo}<span className="hm-table hm-grid"><i>Épreuve</i><i>MATH</i><i>Classe</i><i>Tle C</i><i>DS</i><i>n°</i><i>Durée</i><i>2h</i></span></>,
    8: <><span className="hm-table hm-logo-grid">{logo}<b>SESSION / ATELIER</b><i>Année scolaire</i><small>Tutelle</small><strong>EXAMEN BLANC</strong><em>ÉPREUVE DE MATIÈRE</em><span>CLASSE | DURÉE | COEFF</span></span></>,
    9: <>{bilingual}<span className="hm-delegations">Délégations………………………………Délégations</span>{details}<b className="hm-title">TITRE DE L’ÉPREUVE</b></>,
  };
  return <span className={`ql-header-mock ql-header-mock-${code}`}>{variants[code]}</span>;
}

export default function ExamGeneralOptions({
  draft,
  errors,
  establishments,
  options,
  onFieldChange,
  onContextChange,
  onManageEstablishments,
  showTier = true,
}) {
  const classes = Array.isArray(options.classes) ? options.classes : [];
  const subjects = Array.isArray(options.matieres) ? options.matieres : [];
  const sessions = Array.isArray(options.sessions) ? options.sessions : [];
  const tiers = Array.isArray(options.paliers) ? options.paliers : [];
  const headerStyles = Array.isArray(options.header_styles) ? options.header_styles : [];

  return (
    <section className="ql-exam-card" aria-labelledby="exam-general-title">
      <div className="ql-exam-card-heading">
        <span className="ql-teacher-eyebrow">Étape 1</span>
        <h2 id="exam-general-title">Informations générales</h2>
        <p>Préparez l’en-tête et le contexte pédagogique de l’épreuve.</p>
      </div>

      {establishments.length === 0 ? (
        <div className="ql-exam-empty ql-exam-empty-warning">
          <i className="bi bi-building-exclamation" aria-hidden="true"></i>
          <div>
            <strong>Aucun établissement enregistré</strong>
            <p>Ajoutez votre établissement directement dans l’application.</p>
          </div>
          <button type="button" className="btn btn-outline-primary" onClick={onManageEstablishments}>
            Gérer mes établissements
          </button>
        </div>
      ) : (
        <div className="ql-exam-field ql-exam-field-wide">
          <label htmlFor="exam-establishment">Établissement *</label>
          <select
            id="exam-establishment"
            value={draft.establishmentId}
            onChange={(event) => onFieldChange("establishmentId", event.target.value)}
            aria-invalid={Boolean(errors.establishmentId)}
          >
            <option value="">Sélectionner un établissement</option>
            {establishments.map((item) => <option key={item.id} value={item.id}>{item.nom}</option>)}
          </select>
          <FieldError>{errors.establishmentId}</FieldError>
        </div>
      )}

      <div className="ql-exam-grid">
        <div className="ql-exam-field">
          <label htmlFor="exam-class">Classe *</label>
          <select
            id="exam-class"
            value={draft.classe}
            onChange={(event) => onContextChange("classe", event.target.value)}
            aria-invalid={Boolean(errors.classe)}
          >
            <option value="">Sélectionner une classe</option>
            {classes.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}
          </select>
          <FieldError>{errors.classe}</FieldError>
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-subject">Matière *</label>
          <select
            id="exam-subject"
            value={draft.matiere}
            onChange={(event) => onContextChange("matiere", event.target.value)}
            aria-invalid={Boolean(errors.matiere)}
          >
            <option value="">Sélectionner une matière</option>
            {subjects.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}
          </select>
          <FieldError>{errors.matiere}</FieldError>
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-session">Session *</label>
          <select
            id="exam-session"
            value={draft.session}
            onChange={(event) => onFieldChange("session", event.target.value)}
            aria-invalid={Boolean(errors.session)}
          >
            <option value="">Sélectionner une session</option>
            {sessions.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}
          </select>
          <FieldError>{errors.session}</FieldError>
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-year">Année académique</label>
          <input id="exam-year" value={draft.academicYear} onChange={(event) => onFieldChange("academicYear", event.target.value)} />
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-duration">Durée *</label>
          <input id="exam-duration" value={draft.duration} onChange={(event) => onFieldChange("duration", event.target.value)} aria-invalid={Boolean(errors.duration)} />
          <FieldError>{errors.duration}</FieldError>
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-coefficient">Coefficient <span>(optionnel)</span></label>
          <input id="exam-coefficient" inputMode="decimal" placeholder="Ex : 4" value={draft.coefficient} onChange={(event) => onFieldChange("coefficient", event.target.value)} aria-invalid={Boolean(errors.coefficient)} />
          <FieldError>{errors.coefficient}</FieldError>
        </div>

        <div className="ql-exam-field ql-exam-field-wide">
          <label htmlFor="exam-title">Intitulé</label>
          <input id="exam-title" placeholder="Ex : Évaluation de fin de séquence" value={draft.title} onChange={(event) => onFieldChange("title", event.target.value)} />
        </div>

        <div className="ql-exam-field ql-exam-field-wide">
          <label htmlFor="exam-examiner">Examinateur</label>
          <input id="exam-examiner" value={draft.examiner} onChange={(event) => onFieldChange("examiner", event.target.value)} />
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-period">Période / Séquence</label>
          <input id="exam-period" placeholder="Ex : 2" value={draft.period} onChange={(event) => onFieldChange("period", event.target.value)} />
        </div>

        <div className="ql-exam-field">
          <label htmlFor="exam-date">Date de l’épreuve</label>
          <input id="exam-date" placeholder="Ex : 20/04/2026" value={draft.examDate} onChange={(event) => onFieldChange("examDate", event.target.value)} />
        </div>

        <fieldset className="ql-header-style-field ql-exam-field-wide">
          <legend>Style d’en-tête *</legend>
          <p>Choisissez une maquette. Le contenu réel de votre établissement apparaîtra dans la prévisualisation.</p>
          <div className="ql-header-style-grid">{headerStyles.map((item) => (
            <button key={item.code} type="button" className={`ql-header-style-card ${Number(draft.headerStyle) === Number(item.code) ? "selected" : ""}`} onClick={() => onFieldChange("headerStyle", Number(item.code))} aria-pressed={Number(draft.headerStyle) === Number(item.code)}>
              <strong>{item.code} — {item.label}</strong>
              <HeaderMock code={Number(item.code)} />
            </button>
          ))}</div>
        </fieldset>

        {showTier && <fieldset className="ql-exam-tier-field ql-exam-field-wide">
          <legend>Palier *</legend>
          <div className="ql-exam-tier-options">
            {tiers.map((item) => (
              <label key={item.code} className={draft.tier === item.code ? "selected" : ""}>
                <input type="radio" name="exam-tier" value={item.code} checked={draft.tier === item.code} onChange={(event) => onFieldChange("tier", event.target.value)} />
                <span><strong>{item.label || item.code} — {item.amount} {item.currency || "FCFA"}</strong><small>{item.code === "PREMIUM" ? "PDF sujet, DOCX et PDF corrigé" : "PDF sujet"}</small></span>
              </label>
            ))}
          </div>
          <FieldError>{errors.tier}</FieldError>
        </fieldset>}
      </div>
    </section>
  );
}
